import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Typography, Box } from "@mui/material";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { API_URL, alertMessage } from "../actions/auth";
import { themeStyle, themeStyleDark } from "../components/Components";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PublishIcon from "@mui/icons-material/Publish";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Snackbar from "@mui/material/Snackbar";
import { Link, Navigate } from "react-router-dom";
import CustomQuill from "../components/CustomQuill";
import Select from "@mui/material/Select";

const NewCase = () => {
  const [title, setTitle] = useState("");

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  const [content, setContent] = useState("");
  const [status, setStatus] = useState(false);
  const [category, setCategory] = useState("Digital Marketing");
  const [segment, setSegment] = useState("");
  const [authorsList, setAuthorsList] = useState([]);
  const [selectedAuthor, setSelectedAuthor] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    axios.post(API_URL + "get_authors_list").then((res) => {
      setAuthorsList(res.data);
      setSelectedAuthor(res.data[0]["auth_id"]);
    });
  }, []);

  if (!state.auth.isAuthenticated || state.auth.is_staff) {
    return <Navigate to="/" />;
  }

  function getAuthorsList() {
    var authors = authorsList.map((author, index) => (
      <MenuItem value={author["auth_id"]}>{author["name"]}</MenuItem>
    ));
    return authors;
  }

  function onFileChange(event) {
    // Update the state
    setSelectedFile(event.target.files[0]);
    setOpen(true);
  }

  function onFileUpload() {
    setIsSubmitting(true);
    // Create an object of formData
    const formData = new FormData();

    // Update the formData object
    formData.append("file", selectedFile, selectedFile.name);

    // Details of the uploaded file
    console.log(selectedFile);

    // Request made to the backend api
    // Send formData object

    const config = {
      headers: {
        Authorization: "state.auth.token",
      },
    };

    formData.append("title", title);
    formData.append("meta_title", metaTitle);
    formData.append("meta_description", metaDescription);
    formData.append("category", category);
    formData.append("segment", segment);
    formData.append("content", content);
    formData.append("status", status);
    formData.append("author", selectedAuthor);

    axios
      .post(API_URL + "save_case_study", formData, config)
      .then(() => {
        setIsSubmitting(false);
        dispatch(alertMessage("SUCCESS", "SUCCESS", "Case Study Submitted"));
      })
      .catch((err) => {
        dispatch(alertMessage("ERROR", "ERROR", "An Error Occured."));
      });

    setOpen(false);
    document.getElementById("contained-button-file").value = "";
  }

  function fileData() {
    if (selectedFile) {
      return (
        <div>
          <div
            style={{
              marginTop: "2.2vh",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpen(false)}
                style={{
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                }}
              />
            </IconButton>
          </div>
          <h2>File Details:</h2>
          <p>File Name: {selectedFile.name}</p>
          <p>File Type: {selectedFile.type}</p>

          <br></br>
          <br></br>
          {selectedFile.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  dispatch(
                    alertMessage(
                      "ERROR",
                      "File too big.",
                      "File size should be less than 25 MB."
                    )
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD and SUBMIT
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{
                  width: "100%",
                  fontSize: "15px",
                  height: "35px",
                  backgroundColor: themeStyle.primaryColor,
                }}
              >
                <PublishIcon />
                &nbsp;&nbsp;UPLOAD and SUBMIT
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  if (state.auth.isAuthenticated) {
    if (!state.auth.is_staff) {
      return (
        <div
          style={{
            backgroundColor: "white",
            padding: "6vh",
            minHeight: "100vh",
          }}
        >
          <Snackbar
            open={state.auth.alert != null ? true : false}
            autoHideDuration={6000}
            onClose={() => dispatch({ type: "REMOVE_ALERT" })}
            message={state.auth.alert == null ? "" : state.auth.alert.message}
            action={
              <div
                onClick={() => dispatch({ type: "REMOVE_ALERT" })}
                style={{ padding: "2px", cursor: "pointer" }}
              >
                <CloseIcon />
              </div>
            }
          />

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: themeStyle.backgroundColor,
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  padding: "2.2vh",
                }}
              >
                {fileData()}
              </div>
            </Fade>
          </Modal>
          <div>
            <Typography variant="h4" gutterBottom>
              New Case Study
            </Typography>
            <Button
              onClick={() => navigate("/new_post")}
              style={{
                fontSize: "15px",
                height: "35px",
                backgroundColor: themeStyle.primaryColor,
                border: "2px solid " + themeStyle.primaryColor,
              }}
              variant="contained"
              component="span"
            >
              New Blog Post
            </Button>
          </div>
          <br />

          <div style={{ display: "flex" }}>
            <TextField
              required
              style={{ marginRight: "25px" }}
              label="Meta Title"
              fullWidth
              margin="normal"
              value={metaTitle}
              onChange={(e) => setMetaTitle(e.target.value)}
            />
            <TextField
              required
              label="Meta Description"
              fullWidth
              margin="normal"
              value={metaDescription}
              onChange={(e) => setMetaDescription(e.target.value)}
            />
          </div>

          <TextField
            required
            label="Title of the Post"
            fullWidth
            margin="normal"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <br />
          <br />

          <Box sx={{ mb: 4 }}>
            <CustomQuill
              theme="snow"
              style={{ height: "300px" }}
              value={content}
              onChange={(content) => setContent(content)}
            />
          </Box>
          <TextField
            required
            label="HTML"
            fullWidth
            multiline
            rows={4}
            margin="normal"
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />

          <div style={{ display: "flex" }}>
            <TextField
              required
              style={{ marginRight: "25px" }}
              label="Status"
              select
              fullWidth
              margin="normal"
              value={status == true ? "Published" : "Draft"}
              onChange={(e) =>
                setStatus(e.target.value == "Published" ? true : false)
              }
            >
              <MenuItem value="Draft">Draft</MenuItem>
              <MenuItem value="Published">Published</MenuItem>
            </TextField>
            <Select
              value={selectedAuthor}
              onChange={(e) => setSelectedAuthor(e.target.value)}
              style={{
                height: "55px",
                marginTop: "16px",
              }}
              label="Author"
              fullWidth
              variant={"outlined"}
            >
              {getAuthorsList()}
            </Select>
          </div>
          <div style={{ display: "flex" }}>
            <TextField
              required
              style={{ marginRight: "25px" }}
              label="Category"
              select
              fullWidth
              margin="normal"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <MenuItem value="Digital Marketing">Digital Marketing</MenuItem>
              <MenuItem value="Software">Software</MenuItem>
            </TextField>
            <TextField
              required
              label="Segment"
              fullWidth
              margin="normal"
              value={segment}
              onChange={(e) => setSegment(e.target.value)}
            />
          </div>

          <div style={{ marginTop: "25px" }}>
            <label style={{ width: "100%" }} htmlFor="contained-button-file">
              <input
                style={{ display: "none" }}
                id="contained-button-file"
                type="file"
                onChange={(e) => onFileChange(e)}
              />

              <Button
                style={{
                  width: "100%",
                  fontSize: "15px",
                  height: "35px",
                  backgroundColor: themeStyle.primaryColor,
                }}
                variant="contained"
                component="span"
              >
                Upload Cover Image and submit
              </Button>
            </label>
          </div>
        </div>
      );
    } else {
      return <Navigate to="/" />;
    }
  } else {
    return <Navigate to="/" />;
  }
};

export default NewCase;
